import React from "react";
import { Navigate, useParams } from "react-router-dom";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import ResetPasswordPage from "../pages/Authentication/ResetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ConfirmEmailPage from "../pages/Authentication/ConfirmEmail";

import Home from "../pages/Home/Home";
import SelectFunction from "../pages/Function/SelectFunction";
import SampleGroupings from "../pages/SampleGroupings/SampleGroupings";
import SubcodonProfile from "../pages/SubcodonProfile/SubcodonProfile";
import Help from "../pages/Help/Help";
import FunctionHelp from "../pages/Help/FunctionHelp";
import QuickStart from "../pages/Help/QuickStart";
import FAQ from "../pages/Help/FAQ";
import InviteUser from "../pages/InviteUser/InviteUser";
import DemoData from "../pages/DemoData/DemoData";
import ContactUs from "../pages/ContactUs/ContactUs";
import Updates from "../pages/Updates/Updates";
import Settings from "../pages/Settings/Settings";
import ComparisonProfile from "../pages/ComparisonProfile/ComparisonProfile";
import DataQuality from "../pages/DataQuality/DataQuality";
import DifferentialExpression from "../pages/DifferentialExpression/DifferentialExpression";
import BatchDifferentialExpression from "../pages/DifferentialExpression/BatchDifferentialExpression";
import PauseDetection from "../pages/PauseDetection/PauseDetection";
import BatchPauseDetection from "../pages/PauseDetection/BatchPauseDetection";
import TranslonExplorer from "../pages/TranslonExplorer/TranslonExplorer";
import CodonOccupancy from "../pages/CodonOccupancy/CodonOccupancy";
import BatchCodonOccupancy from "../pages/CodonOccupancy/BatchCodonOccupancy";
import TranscriptomeInfo from "../pages/TranscriptomeInfo/TranscriptomeInfo";
import TimeSeries from "../pages/TimeSeries/TimeSeries";
import PolyShift from "../pages/PolyShift/PolyShift";
import ShortCodeRedirector from "../pages/ShortCodeRedirector/ShortCodeRedirector";
import BatchSubcodonProfile from "../pages/BatchSubcodonProfile/BatchSubcodonProfile";
import BatchComparisonProfile from "../pages/ComparisonProfile/BatchComparisonProfile";
import SingleGenomeBrowser from "../pages/SingleGenomeBrowser/SingleGenomeBrowser";
import DifferentialSilhouette from "../pages/DifferentialSilhouette/DifferentialSilhouette";
import BatchDifferentialSilhouette from "../pages/DifferentialSilhouette/BatchDifferentialSilhouette";
import DifferentialCdsLeader from "../pages/DifferentialCdsLeader/DifferentialCdsLeader";
import BatchDifferentialCdsLeader from "../pages/DifferentialCdsLeader/BatchDifferentialCdsLeader";
import RRTS from "../pages/RRTS/RRTS";
import UTRPeriodicity from "../pages/UTRPeriodicity/UTRPeriodicity";
import TerminationMetagene from "../pages/TerminationMetagene/TerminationMetagene";
import ComparisonGenomeBrowser from "../pages/ComparisonGenomeBrowser/ComparisonGenomeBrowser";

// Ensures that if a user navigates to /projects/${projectId} it will redirect to 
// /projects/${projectId}/select-function  
// without this it would redirect to homepage which could accidentally show customer
// projects when doing a demo/workshop
const ProjectBaseRedirect = () => {
  const { projectId } = useParams();
  return <Navigate to={`/projects/${projectId}/select-function`} replace />;
};

const authProtectedRoutes = [
  // Home
  { path: "/dashboard", component: <Home /> },

  // Help

  { path: "/help", component: <Help /> },
  { path: "/help/plot/:plotId", component: <FunctionHelp /> },
  { path: "/help/quickstart", component: <QuickStart /> },
  { path: "/help/faq", component: <FAQ /> },

  // Invite User
  { path: "/invite-user", component: <InviteUser /> },

  // Demo Data
  { path: "/demo-data", component: <DemoData /> },

  // Contact Us
  { path: "/contact-us", component: <ContactUs /> },

  // Updates
  { path: "/updates", component: <Updates /> },

  // Settings
  { path: "/settings", component: <Settings /> },

  // Function
  {
    path: "/projects/:projectId/select-function",
    component: <SelectFunction />,
  },

  {
    path: "/projects/:projectId",
    component: <ProjectBaseRedirect />,
  },

  //Condition Groups
  {
    path: "/projects/:projectId/sample_groupings",
    component: <SampleGroupings />,
  },

  //Short Code Redirector
  {
    path: "/short/:shortCode",
    component: <ShortCodeRedirector />,
  },

  // Plot

  {
    path: "/projects/:projectId/interactive_plot/",
    component: <SubcodonProfile />,
  },

  {
    path: "/projects/:projectId/batch_profiles/",
    component: <BatchSubcodonProfile />,
  },

  {
    path: "/projects/:projectId/comparison/",
    component: <ComparisonProfile />,
  },
  {
    path: "/projects/:projectId/batch_comparison_profiles/",
    component: <BatchComparisonProfile />,
  },
  {
    path: "/projects/:projectId/metainfo_plot/",
    component: <DataQuality />,
  },
  {
    path: "/projects/:projectId/differential/",
    component: <DifferentialExpression />,
  },
  {
    path: "/projects/:projectId/batch_differential/",
    component: <BatchDifferentialExpression />,
  },
  {
    path: "/projects/:projectId/pause_detection/",
    component: <PauseDetection />,
  },
  {
    path: "/projects/:projectId/batch_pause_detection/",
    component: <BatchPauseDetection />,
  },
  {
    path: "/projects/:projectId/translon_explorer/",
    component: <TranslonExplorer />,
  },
  {
    path: "/projects/:projectId/codon_occupancy/",
    component: <CodonOccupancy />,
  },
  {
    path: "/projects/:projectId/batch_codon_occupancy/",
    component: <BatchCodonOccupancy />,
  },
  {
    path: "/projects/:projectId/traninfo_plot/",
    component: <TranscriptomeInfo />,
  },
  {
    path: "/projects/:projectId/time_series/",
    component: <TimeSeries />,
  },
  {
    path: "/projects/:projectId/poly_shift/",
    component: <PolyShift />,
  },
  {
    path: "/projects/:projectId/differential_silhouette/",
    component: <DifferentialSilhouette />,
  },
  {
    path: "/projects/:projectId/batch_differential_silhouette/",
    component: <BatchDifferentialSilhouette />,
  },
  {
    path: "/projects/:projectId/diff_leader_cds/",
    component: <DifferentialCdsLeader />,
  },
  {
    path: "/projects/:projectId/batch_diff_leader_cds/",
    component: <BatchDifferentialCdsLeader />,
  },
  {
    path: "/projects/:projectId/rrts/",
    component: <RRTS />,
  },
  {
    path: "/projects/:projectId/utr_periodicity/",
    component: <UTRPeriodicity />,
  },
  {
    path: "/projects/:projectId/termination_metagene/",
    component: <TerminationMetagene />,
  },
  {
    path: "/projects/:projectId/single_genomebrowser/",
    component: <SingleGenomeBrowser />,
  },
  {
    path: "/projects/:projectId/comparison_genomebrowser/",
    component: <ComparisonGenomeBrowser />,
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPasswordPage /> },
  { path: "/confirm-email", component: <ConfirmEmailPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
